"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportClient = exports.TransportClientClass = void 0;
var models_1 = require("src/models");
var helpers_1 = require("src/helpers");
var errors_1 = require("src/errors");
/**
 * Simple service for sending HTTP requests. Used internally
 * by the various clients.
 */
var TransportClientClass = /** @class */ (function () {
    function TransportClientClass() {
    }
    /**
     * A helper method for generating a GET request. This method also
     * enables caching requests.
     */
    TransportClientClass.prototype.get = function (url, params, headers, timeout, responseType) {
        return this.request(this.buildRequest(url, models_1.RequestMethods.get, undefined, headers, timeout, params, responseType));
    };
    // Typescript does not allow for required parameters after optional parameters
    // Therefore the get method cannot be overloaded for Blobs without effecting the overall API
    TransportClientClass.prototype.getBlob = function (url, params, headers, timeout) {
        var req = this.buildRequest(url, models_1.RequestMethods.get, undefined, headers, timeout, params, models_1.ResponseType.blob);
        return this.request(req);
    };
    /**
     * A helper method for generating a POST request
     */
    TransportClientClass.prototype.post = function (url, data, headers, timeout, params) {
        return this.request(this.buildRequest(url, models_1.RequestMethods.post, data, headers, timeout, params));
    };
    /**
     * A helper method for generating a PUT request
     */
    TransportClientClass.prototype.put = function (url, data, headers, timeout, params) {
        return this.request(this.buildRequest(url, models_1.RequestMethods.put, data, headers, timeout, params));
    };
    /**
     * A helper method for generating a DELETE request
     */
    TransportClientClass.prototype.delete = function (url, data, headers, timeout, params) {
        return this.request(this.buildRequest(url, models_1.RequestMethods.delete, data, headers, timeout, params));
    };
    TransportClientClass.prototype.request = function (config) {
        var _this = this;
        if (!(0, helpers_1.isRequest)(config))
            throw new errors_1.InvalidParamError('Invalid Request');
        var headers = config.headers || { accept: models_1.DataFormatTypes.default };
        var request = new XMLHttpRequest();
        var url = this.buildUrl(config.url, config.params);
        request.open(config.method, url, true);
        Object.keys(headers).forEach(function (key) {
            var value = headers[key];
            if (typeof value !== 'undefined') {
                request.setRequestHeader(key, value);
            }
        });
        if (typeof config.timeout !== 'undefined')
            this.handleTimeout(request, config.timeout);
        if (!!config.responseType)
            request.responseType = config.responseType;
        return new Promise(function (resolve, reject) {
            request.onload = function () {
                var _a;
                try {
                    if (config.responseType === models_1.ResponseType.blob) {
                        resolve(new Blob([request.response], {
                            type: (_a = request.getResponseHeader('content-type')) !== null && _a !== void 0 ? _a : undefined,
                        }));
                    }
                    else {
                        var response = _this.parseResponse(request, (0, helpers_1.isDataFormatTypes)(config.headers)
                            ? config.headers.accept
                            : models_1.DataFormatTypes.default);
                        resolve(response);
                    }
                }
                catch (err) {
                    reject(err);
                }
            };
            request.onerror = function (err) { return reject(err); };
            request.send(config.data);
        });
    };
    TransportClientClass.prototype.buildRequest = function (url, method, data, headers, timeout, params, responseType) {
        if (!(0, helpers_1.isString)(url))
            throw new errors_1.InvalidParamError('Invalid URL');
        if (!(0, helpers_1.isRequestMethods)(method))
            throw new errors_1.InvalidParamError(JSON.stringify(method));
        if (!(0, helpers_1.isUndefined)(data) &&
            !(0, helpers_1.isString)(data) &&
            !(0, helpers_1.isFile)(data) &&
            !(0, helpers_1.isFormData)(data)) {
            throw new errors_1.InvalidParamError('Missing or Invalid Request Body');
        }
        if (!(0, helpers_1.isUndefined)(params) && !(0, helpers_1.isString)(params)) {
            throw new errors_1.InvalidParamError('Invalid Request Parameters');
        }
        if (!(0, helpers_1.isUndefined)(headers) && !(0, helpers_1.isRequestHeaders)(headers)) {
            throw new errors_1.InvalidParamError('Invalid Request Headers');
        }
        if (!(0, helpers_1.isUndefined)(timeout) && !(0, helpers_1.isNumber)(timeout) && !(0, helpers_1.isPromise)(timeout)) {
            throw new errors_1.InvalidParamError('Missing or Invalid Timeout Parameter');
        }
        if (!(0, helpers_1.isUndefined)(responseType) && !(0, helpers_1.isResponseType)(responseType)) {
            throw new errors_1.InvalidParamError('Invalid Response Type Provided');
        }
        var req = {
            url: url,
            headers: headers,
            data: data,
            timeout: timeout,
            method: method,
            params: params,
            responseType: responseType,
        };
        this.setAuthTokenHeader(req);
        return req;
    };
    TransportClientClass.prototype.parseResponse = function (request, accept) {
        var statusOK = 200;
        var statusBad = 400;
        if (request.status >= statusOK && request.status < statusBad) {
            var data = void 0;
            try {
                data =
                    accept === models_1.DataFormatTypes.default || accept === models_1.DataFormatTypes.json
                        ? JSON.parse(request.responseText)
                        : request.responseText;
            }
            catch (e) {
                return { status: 'OK', statusCode: request.status };
            }
            return { data: data, status: 'OK', statusCode: request.status };
        }
        throw new Error("Status: ".concat(request.status, " - ").concat(request.responseText));
    };
    TransportClientClass.prototype.handleTimeout = function (req, timeout) {
        if ((0, helpers_1.isNumber)(timeout) && timeout > 0) {
            setTimeout(function () { return req.abort(); }, timeout);
        }
        else if ((0, helpers_1.isPromise)(timeout)) {
            timeout.then(function () { return req.abort(); });
        }
    };
    TransportClientClass.prototype.buildUrl = function (url, params) {
        return typeof params === 'string' && params.length !== 0
            ? "".concat(url, "?").concat(params)
            : url;
    };
    TransportClientClass.prototype.setAuthTokenHeader = function (req) {
        var token = window.__RYUU_AUTHENTICATION_TOKEN__;
        if (req.headers !== undefined && Boolean(token)) {
            req.headers['X-DOMO-Ryuu-Token'] = token;
        }
    };
    return TransportClientClass;
}());
exports.TransportClientClass = TransportClientClass;
exports.TransportClient = new TransportClientClass();
